const cognitoSettingsQuery = () => {

    switch (process.env.REACT_APP_SELECTED_ENV) {
        case "QA": {
            if (process.env.REACT_APP_DEPLOY_ENV === "prod") {
                return {
                    REACT_APP_COGNITO_USER_POOL_CLIENT_ID: "74935ca372ugnvbo8sa1e5hv0",
                    REACT_APP_COGNITO_USER_POOL_ID: "us-east-1_k7I1vtxH3",
                }
            }
            return {
                REACT_APP_COGNITO_USER_POOL_CLIENT_ID: "3h3v3fatd5bji65kma6tt8mrvp",
                REACT_APP_COGNITO_USER_POOL_ID: "us-east-1_5ze62Yo0b",
            }
        }
        case "EXECUTIVE": {
            if (process.env.REACT_APP_DEPLOY_ENV === "prod") {
                return {
                    REACT_APP_COGNITO_USER_POOL_CLIENT_ID: "7hbqj9cs8vof4987tqteac713l",
                    REACT_APP_COGNITO_USER_POOL_ID: "us-east-1_k7I1vtxH3",
                }
            }
            return {
                REACT_APP_COGNITO_USER_POOL_CLIENT_ID: "4r7hgcu0fd990ihntpt4msamk0",
                REACT_APP_COGNITO_USER_POOL_ID: "us-east-1_5ze62Yo0b",
            }
        }
        case "HR": {
            if (process.env.REACT_APP_DEPLOY_ENV === "prod") {
                return {
                    REACT_APP_COGNITO_USER_POOL_CLIENT_ID: "2aah1fvm1h4mu6lf90hjhp62sa",
                    REACT_APP_COGNITO_USER_POOL_ID: "us-east-1_GJNtxlfe9",
                }
            }
            return {
                REACT_APP_COGNITO_USER_POOL_CLIENT_ID: "28menavhk49dlhtl9mct6mv2h2",
                REACT_APP_COGNITO_USER_POOL_ID: "us-east-1_cWcrukRf1",
            }
        }
        case "ADMIN": {
            if (process.env.REACT_APP_DEPLOY_ENV === "prod") {
                return {
                    REACT_APP_COGNITO_USER_POOL_CLIENT_ID: "4v4625kciatanpiurjvrf7f04f",
                    REACT_APP_COGNITO_USER_POOL_ID: "us-east-1_k7I1vtxH3",
                }
            }
            return {
                REACT_APP_COGNITO_USER_POOL_CLIENT_ID: "7v3886cjh9i7o7l2drv9oq63be",
                REACT_APP_COGNITO_USER_POOL_ID: "us-east-1_5ze62Yo0b",
            }
        }
        case "CANDIDATE": {
            if (process.env.REACT_APP_DEPLOY_ENV === "prod") {
                return {
                    REACT_APP_COGNITO_USER_POOL_CLIENT_ID: "659q7431j3urnlgl2gjniqak8t",
                    REACT_APP_COGNITO_USER_POOL_ID: "us-east-1_KIpyf20PC",
                }
            }
            return {
                REACT_APP_COGNITO_USER_POOL_CLIENT_ID: "4iqfpdcsb3dle9dkuquni9pkac",
                REACT_APP_COGNITO_USER_POOL_ID: "us-east-1_d62mv1ItY",
            }
        }
    }

}

export default cognitoSettingsQuery
